const FIconWrapper = ({ children }) => {
  return <div className="icon-wrapper flex items-center gap-1">{children}</div>
}
export default FIconWrapper
